/** Quiet periods, in milliseconds, before a debounced call runs. */
export const DEBOUNCE_MS = {
  /** After the last keystroke in a search field, before the search request. */
  search: 300,
  /** After the last cart edit, before the pricing preview request. */
  pricingPreview: 350,
  /** After the last form edit, before the draft is captured. */
  draftCapture: 500,
  /** Triggers fired in the same turn coalesce into one call. */
  sameTurn: 0
} as const
